export default __webpack_public_path__ + "static/media/maintenance.3efa09d2.svg";